import { _ as _extends } from './_rollupPluginBabelHelpers-8c92bac3.js';
import React__default from 'react';

const IconQuestionFilled = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("path", {
  d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1.424-8.4h2.176v-.24c0-.688.24-1.152.912-1.792 1.008-.944 1.44-1.728 1.44-2.704C15.104 7.2 13.648 6 11.728 6 10.16 6 8.72 6.816 8 8.032c.864.592 1.28.912 1.744 1.232.448-.704 1.104-1.136 1.792-1.136.704 0 1.168.4 1.168.992 0 .4-.192.72-.864 1.44-.912 1.024-1.264 1.664-1.264 2.496v.544zm1.088 4.36c.816 0 1.504-.672 1.504-1.488 0-.784-.688-1.472-1.504-1.472-.816 0-1.504.672-1.504 1.472 0 .832.688 1.488 1.504 1.488z",
  className: 'motorway-svg-fill',
  fillRule: "evenodd"
}));

export { IconQuestionFilled as I };
